import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';

type Props = { id: string; onRelease: () => void };

// A link can lock the field to an address someone else controls, so the person is told
// to stop when it is not theirs and can drop the invitation instead.
export function InvitedEmailHint({ id, onRelease }: Props) {
  const t = useTranslations('auth.register.invited');

  return (
    <div className="flex flex-col items-start gap-1">
      <p id={id} className="text-xs text-muted-foreground">
        <span>{t('lockedHint')}</span> <span>{t('notYoursWarning')}</span>
      </p>
      <Button
        type="button"
        variant="link"
        size="sm"
        className="h-auto p-0 text-xs text-foreground underline"
        onClick={onRelease}
      >
        {t('notMine')}
      </Button>
    </div>
  );
}
